// Filtering is client-side (see filterEventsByPayload), so these values are only internal operator
// keys. They are deliberately kept identical to the Control API PropertyOp enum names so a future
// server-side variant could forward them to search_events unchanged.
const PAYLOAD_CONDITION_OPERATORS = {
  EQUALS: 'PROPERTY_OP_EQUALS',
  NOT_EQUALS: 'PROPERTY_OP_NOT_EQUALS',
  CONTAINS: 'PROPERTY_OP_CONTAINS',
  EXISTS: 'PROPERTY_OP_EXISTS',
  NOT_EXISTS: 'PROPERTY_OP_NOT_EXISTS',
};

export default PAYLOAD_CONDITION_OPERATORS;

export const PAYLOAD_CONDITION_OPERATOR_OPTIONS = [
  { label: 'Equals', value: PAYLOAD_CONDITION_OPERATORS.EQUALS },
  { label: 'Does not equal', value: PAYLOAD_CONDITION_OPERATORS.NOT_EQUALS },
  { label: 'Contains', value: PAYLOAD_CONDITION_OPERATORS.CONTAINS },
  { label: 'Exists', value: PAYLOAD_CONDITION_OPERATORS.EXISTS },
  { label: 'Is null or absent', value: PAYLOAD_CONDITION_OPERATORS.NOT_EXISTS },
];

export const VALUELESS_OPERATORS = [PAYLOAD_CONDITION_OPERATORS.EXISTS, PAYLOAD_CONDITION_OPERATORS.NOT_EXISTS];
